import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import React, { useEffect, useState } from 'react'
import tw from 'twin.macro'

const denominations = [
  {
    value: '10000',
    label: '10 000 ₸'
  },
  {
    value: '20000',
    label: '20 000 ₸'
  },
  {
    value: '50000',
    label: '50 000 ₸'
  },
  {
    value: '100000',
    label: '100 000 ₸'
  },
  {
    value: '200000',
    label: '200 000 ₸'
  }
]

import { Button } from 'components/UI/button/button'
import CurrencyFormat from 'react-currency-format'
import { useTranslation } from 'react-i18next'
import { ClipLoader } from 'react-spinners'
import { useGetPrepaidGeneralInfoQuery, useGetProductsQuery } from 'redux/api/buy-card.api'
import { useLkOrderMutation } from 'redux/api/lk.api'

import BuyCardLkModal from '../buy-card-lk-modal'
import MegaSyiliq from './../../../assets/images/nominal-img.webp'
import CardlimitContainer from '../card-limit-container'

function CabinetBuyCardContainer() {
  const [open, setOpen] = useState<boolean>(false)
  const [errorText, setErrorText] = useState<string>('')
  const [cardLimit, setCardLimit] = useState<boolean>(false)

  const { data, isLoading, error } = useGetProductsQuery(null)
  const [order, { isSuccess, isLoading: orderLoading, error: orderError }] = useLkOrderMutation()

  const [active, setActive] = useState<{ product_code: string; amount: string }>(data?.data.products[0])

  const { t } = useTranslation()

  const handleCloseModal = () => {
    setOpen(false)
  }
  const handleBuyCard = async () => {
    try {
      await order({ product_code: active.product_code }).unwrap()
    } catch (e) {
      const typedErr = e as {
        data: {
          error: { description: string; code: string }
        }
        status: number
      }
      if (typedErr.data.error.code === 'INVALID_OTP') {
        setOpen(true)
      }
      if (
        typedErr.data.error.code === 'UNFINISHED_APPLICATION' &&
        typeof typedErr.data.error.description === 'string'
      ) {
        setErrorText(typedErr.data.error.description)
      }
      if (typedErr.data.error.code === 'LIMIT_CARD_ERROR') {
        setErrorText(typedErr.data.error.description)
      }
    }
  }

  useEffect(() => {
    if (isSuccess) {
      isSuccess && setOpen(true)
    }
  }, [isSuccess])

  useEffect(() => {
    data?.data.products && setActive(data.data.products[0])
  }, [data])

  return (
    <>
      <div tw='bg-secondary rounded-s32 pt-20 sm:px-20 p-10 relative gap-2 overflow-hidden w-full flex sm:flex-row flex-col sm:items-end items-center sm:h-auto h-[900px] justify-between w-full mt-20'>
        <div tw='flex flex-col justify-between pb-20 relative sm:z-20 gap-10 w-full '>
          {error ? (
            <div>
              <Title variant='bold'>{t('tech_error.not_available', { ns: 'badcases' })}</Title>
              <SubTitle>{t('tech_error.try_again', { ns: 'badcases', limit: '10' })}</SubTitle>
            </div>
          ) : (
            <>
              {' '}
              <Title className='green-gradiented-text' twStyle={tw`text-green-secondary`} variant='bold'>
                {t('gift_card.container_1.title', {
                  ns: 'landing',
                  nominal: `${active ? Number(active?.amount).toLocaleString() : ''} ₸`
                })}
              </Title>
              <div>
                <SubTitle twStyle={tw`text-secondary`} variant='medium'>
                  {t('gift_card.container_1.subtitle', { ns: 'landing', nominal: '10 000' })}
                </SubTitle>
                <div tw='grid sm:grid-cols-3 grid-cols-2 gap-3 max-w-max mt-5'>
                  {isLoading ? (
                    <ClipLoader />
                  ) : (
                    data?.data.products.map((item: { product_code: string; amount: string }, idx: number) => (
                      <NominalButton
                        data={item}
                        onClick={nominal => setActive(nominal)}
                        active={active}
                        key={`${item.product_code}${idx}`}
                      />
                    ))
                  )}
                </div>
              </div>
            </>
          )}

          <div tw='h-[70px]'>
            <Button
              twStyle={tw`sm:max-w-max sm:mt-0 mt-[8px]`}
              disabled={orderLoading || !active || Boolean(error) || Boolean(orderError)}
              loading={orderLoading}
              variant='gradient'
              onClick={handleBuyCard}
            >
              {t('gift_card.container_1.button_text', { ns: 'landing' })}
            </Button>
            <p tw='relative top-2 text-error w-full text-s12 font-bold max-w-[300px]'>{errorText}</p>
          </div>
        </div>
        <img src={MegaSyiliq} alt='' width={494} height={441} tw='absolute bottom-0 max-h-[441px] sm:right-20' />
      </div>
      <BuyCardLkModal onClose={handleCloseModal} open={open} denomination={active} />
    </>
  )
}
const NominalButton = ({
  data,
  onClick,
  active
}: {
  data: { product_code: string; amount: string }
  onClick: (active: any) => void
  active: { product_code: string; amount: string }
}) => {
  return (
    <button
      tw='rounded-s32 w-[126px] h-[48px] py-3 bg-primary font-semibold border border-[#f5f6f7]'
      onClick={() => onClick(data)}
      css={[active?.product_code === data?.product_code && tw`bg-selector border border-green-lighter text-green`]}
    >
      <CurrencyFormat
        value={data.amount}
        displayType={'text'}
        format={parseInt(data.amount) < 100000 ? '## ######' : '### #####'}
      />
      ₸
    </button>
  )
}

export default CabinetBuyCardContainer
